import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';

import { api, useAPIContext } from '../../api/context';
import toast from '../../utils/toast';
import Base from '../Base';
import styles from './ForgotConfirm.module.scss';

const ForgotConfirm = () => {

  const [ loading, setLoading ] = useState(false);
  const [ params ] = useSearchParams();

  const email = params.get('email');

  const navigate = useNavigate();

  useEffect(() => {
    if (!email) {
      navigate('/');
    }
  }, [email, navigate]);

  const { setToken } = useAPIContext();

  const next = (values) => {

    const TARGET = '/campaigns';

    setLoading(true);

    api().v1.auth.login
      .post({
        email,
        password: values.password,
      })
      .then(res => {
        setLoading(false);

        if (res.status === 200) {
          setToken(res.body.token);
          navigate(TARGET);
        }

        if (res.status === 400) {
          toast.show(toast.KIND.ERROR, res.body);
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  };

  return (
    <Base title='Enter Code'>
      <div className={styles.root}>
        <Formik
          initialValues={{
            code: '',
            password: '',
          }}
          validationSchema={yup.object({
            code: yup.string()
              .required('Code required'),
            password: yup.string()
              .required('Password required'),
          })}
          onSubmit={(values, actions) => {

            if (loading) {
              return;
            }

            setLoading(true);

            api().v1.auth.forgot.confirm
              .post({
                email,
                ...values,
              })
              .then(res => {
                setLoading(false);

                if (res.status === 201) {
                  actions.resetForm();
                  next(values);
                }

                if (res.status === 400) {
                  toast.show(toast.KIND.ERROR, res.body);
                }
              })
              .catch(err => {
                setLoading(false);
                toast.show(toast.KIND.WARNING, err);
              });

          }}
          >

          <Form>
            <div>
              <Field
                aria-label='code'
                placeholder='Code'
                name='code'
                type='text'
                disabled={loading}
              />
              <ErrorMessage
                name='code'
                component='div'
              />
            </div>

            <div>
              <Field
                aria-label='new password'
                placeholder='New Password'
                name='password'
                type='password'
                disabled={loading}
              />
              <ErrorMessage
                name='password'
                component='div'
              />
            </div>

            <button
              aria-label='reset password'
              type='submit'
              disabled={loading}>

              Reset Password

            </button>
          </Form>

        </Formik>
      </div>
    </Base>
  );
};

export default ForgotConfirm;